export const PAGINATION_VALUES = {
  DEFAULT_PAGE_SIZE: 50,
  DEFAULT_PAGE_NUMBER: 1,
  PAGE_SIZE_OPTIONS: [10, 20, 25, 50, 100] as const,
};

export const demoGraphicValue = {
  RACE: ['Black', 'White', 'Asian', 'Hispanic'],
};

export const demoGraphicCategory = {
  GENDER: 'Gender',
  RACE: 'Race',
};

export const wageType = {
  Annual: 'Annual',
  Hourly: 'Hourly',
};

export const Quartile = {
  val: 'quartile',
  pay: 'Pay',
};

export const apiMappingValues = {
  F: 'F',
  Female: 'Female',
  M: 'M',
  Male: 'Male',
  O: 'O',
  Other: 'Other',
  All: 'ALL',
  Both: 'Both',
  Black: 'Black',
  White: 'White',
  Asian: 'Asian',
  Hispanic: 'Hispanic',
};

export const quartiles = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
};

export const RE_RUN_REPORT_CONSTANTS = {
  COMPATIBILITY_REVIEW: 'compatibility_review',
  POPULATION_SCOPE: 'population_scope',
};

export const numericAndDotAndDashRegex = /[^0-9.-]/g;

export const defaultHeaderWidth = {
  defaultCheckboxWidth: 48,
  totalWidthPercentage: 100,
};

export const defaultExcelDateFormat = 'MMMM D YYYY';

export const totalBreakDownFileInfo = {
  fileName: 'Total Remediation Cost Breakdown.xlsx',
  sheetName: 'TR Cost Breakdown',
  total:'TOTAL'
};

export const totalBreakDownTableInfo = {
  year1: 'Year 1',
  year2: 'Year 2',
};

export const headerIDS = {
  PROPOSED_PAY_ADJUSTMENT: 'proposed_pay_adjustment',
  ADJUSTED_PAY_GAP: 'adjusted_pay_gap',
};

export interface TimeFrameOption {
  value: string;
  label: string;
}

export const timeFrameOptions: TimeFrameOption[] = [
  {
    value: '1',
    label: '1 year',
  },
  {
    value: '2',
    label: '2 years',
  },
];

export const DEFAULT_LANGUAGE_CODE = 'en';